import Link from 'next/link';
import { Typography } from '@/lib/mui';
import WhiteNarvarLogoShort from './icons/WhiteNarvarLogoShort';

export default function NarvarPreferencesLogo() {
  return (
    <Link href="/" style={{ textDecoration: 'none', display: 'flex' }}>
      <WhiteNarvarLogoShort />
      <Typography pl={2} color="#fff" variant="h5" lineHeight="inherit">
        Preferences
      </Typography>
    </Link>
  );
}
